<div class="title">
    <span>{{ 'dashboard:Transfer ownership' | i18next }}</span>
</div>
<div class="dialog-content">
    <div class="owner-text">{{ 'dashboard:Change owner for' | i18next }} '{{ dashboardName }}'</div>
    <div class="select-container">
        <div>
            <ng-select [items]="owners" bindLabel="name" bindValue="userId" placeholder="{{ 'Select'| i18next }}"
                [(ngModel)]="ownerId" class="select-owner" [appendTo]="'#ddl-panel-wrapper'">
                <ng-template ng-option-tmp let-item="item" let-index="index"
                    dropdownPosition="bottom">
                    <div class="ng-option-template">
                        {{item.name}}
                    </div>
                </ng-template>
            </ng-select>
        </div>
    </div>
</div>

<mat-dialog-actions>
    <button matButton class="secondary-button" (click)="onCancel()">{{ 'Cancel' | i18next }}</button>
    <button matButton class="primary-button" (click)="onConfirm()" [disabled]="isApplyDisabled()">{{ 'Confirm' | i18next }}</button>
</mat-dialog-actions>
